<button class="link-with-arrow" matRipple [matRippleUnbounded]="true" [matRippleRadius]="30" tabindex="0" (click)="linkClick.emit()">
  <mat-icon class="link-with-arrow-icon">arrow_right</mat-icon>
  <div class="link-with-arrow-label"><ng-content></ng-content></div>
</button>
